import React from 'react';
import dayjs from 'dayjs';
import classnames from 'classnames';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { ViewProduct } from '../../../models/ViewProduct.model';
import { HoneyloveWindow } from '../../../models/HoneyloveWindow';
import { PageContext } from '../../../enums/PageContext.enum';
import { SubContext } from '../../../enums/SubContext.enum';
import { SelectionType } from '../../../enums/SelectionType.enum';
import { collectionSelectedVariantFamily, mobileMenuOpenState, pageContextState } from '../../../recoil/atoms';
import { ProductHandle } from '../../../enums/ProductHandle.enum';
import { scrollToTop, sizeImage } from '../../../util';
import { Direction, useProductAssets } from '../../../hooks/useProductAssets';
import { blankImage } from '../../../product_detail/components/ImageLoader';
import { LazyImageLoader } from '../../../product_detail/components/LazyImageLoader';
import { useProductSelection } from '../../../hooks/useProductSelection';
import styles from './MobileNavMenuLink.module.scss';

declare const window: HoneyloveWindow;

interface Props {
  product: ViewProduct;
  index: number;
}

export const MobileNavMenuLink: React.FC<Props> = ({ product, index }) => {
  const pageContext = useRecoilValue(pageContextState);
  const selectionType = SelectionType.ProductSection;
  const { setHandle, setSubContext } = useProductSelection(selectionType);
  const setMenuOpen = useSetRecoilState(mobileMenuOpenState);
  const isNew = dayjs().isBefore(dayjs(product.published_at).add(1, 'month')) && product.handle !== ProductHandle.SculptwaveCapri;
  const productTitle = product.title;

  const photos = useProductAssets(product);
  const [selectedVariant] = useRecoilState(collectionSelectedVariantFamily(product.handle));
  const filteredMannequinPhotos = photos.mannequinPhotos.filter(({ color, direction }) => color === selectedVariant.color && direction === Direction.Front);
  const mainPhoto = filteredMannequinPhotos[0] ?? { src: blankImage };
  const mainPhotoSrc = sizeImage(mainPhoto.src, '350x443');

  return (
    <div key={index} className={styles.hlNavSublinkWrapper} style={{ borderColor: 'transparent' }}>
      <button
        id={`mobile-nav-${product.handle}`}
        data-track-label={productTitle}
        data-track-location="mobile-menu"
        className={styles.hlMobileNavLink}
        onClick={() => handleLink(product, pageContext, setMenuOpen, setHandle, setSubContext)}
      >
        <LazyImageLoader src={mainPhotoSrc} alt={`${product.title}`} />
        <div className={classnames(styles.hlProductMobileNavDescription, { [styles.new]: isNew })}>{product.title}</div>
        <div />
      </button>
    </div>
  );
};

const handleLink = (
  product: ViewProduct,
  pageContext: PageContext | undefined,
  setMenuOpen: (isOpen: boolean) => void,
  selectStyle: (handle: ProductHandle) => void,
  setSubContext: (subContext: SubContext) => void,
) => {
  if (pageContext !== PageContext.ProductPage) {
    if (typeof window !== 'undefined') {
      window.location.href = `/products/${product.handle}`;
    }
  } else {
    selectStyle(product.handle);
    setSubContext(SubContext.MobileMenu);
    setMenuOpen(false);
    scrollToTop();
  }
};

export default MobileNavMenuLink;
